<template>
  <div class="bg-[#D9D9D9] flex flex-col items-center">
    <h1 class="text-3xl font-medium tracking-tight text-black sm:text-4xl mb-4 mt-4">
      Współpraca
    </h1>
    <div class="sm:w-[50%] w-[80%] h-[1px] bg-black mx-auto" />
    <div class="overflow-hidden relative py-4 sm:w-[50%] w-[80%] mx-auto">
      <div class="flex w-max animate-scroll items-center">
        <div
            v-for="(company, index) in infiniteCompanies"
            :key="index"
            class="flex items-center justify-center mx-4"
            :class="company.sizeClass"
        >
          <a
              :href="company.url"
              target="_blank"
              rel="noopener noreferrer"
              class="block"
          >
            <img
                :src="company.logo"
                :alt="company.name"
                class="object-contain"
                :class="company.sizeClass"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="sm:w-[50%] w-[80%] h-[1px] bg-black mx-auto mb-16" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      companies: [
        {
          name: "Boske Art",
          logo: "/images/contractors/boske art.png",
          sizeClass: "w-36 h-36",
          url: "https://www.boskeart.pl/",
        },
        {
          name: "Kara-Design",
          logo: "/images/contractors/kara-design.png",
          sizeClass: "w-36 h-36",
          url: "http://karadesign.pl/",
        },
        {
          name: "Machina",
          logo: "/images/contractors/machina.png",
          sizeClass: "w-36 h-36",
          url: "https://machinaarchitekci.pl/",
        },
        {
          name: "Proyektoria",
          logo: "/images/contractors/proyektoria.png",
          sizeClass: "w-36 h-36",
          url: "https://www.proyektoria.pl",
        },
        {
          name: "Studio-m-kwadrat",
          logo: "/images/contractors/studiomkwadrat.png",
          sizeClass: "w-36 h-36",
          url: "https://www.studiomkwadrat.pl/",
        },
        {
          name: "Symetria",
          logo: "/images/contractors/symetria.png",
          sizeClass: "w-16 h-16",
          url: "https://symetria.pl/en/",
        },
        {
          name: "Revel",
          logo: "/images/contractors/revel.png",
          sizeClass: "w-24 h-24",
        },
        {
          name: "Oyka",
          logo: "/images/contractors/oyka.png.avif",
          sizeClass: "w-24 h-24",
          url: "https://www.oyka.pl",
        },
      ],
    };
  },
  computed: {
    infiniteCompanies() {
      return [...this.companies, ...this.companies, ...this.companies];
    },
  },
};
</script>

<style scoped>
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-33.33%);
  }
}

.animate-scroll {
  display: flex;
  white-space: nowrap;
  animation: scroll 16s linear infinite;
}
</style>
